import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { roomAvailabilitiesActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { RoomsService } from '../../services/rooms.service';

@Injectable({
  providedIn: 'root',
})
export class RoomAvailabilitiesEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private roomsService: RoomsService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(roomAvailabilitiesActions.findAll),
      switchMap((action) => {
        return this.roomsService
          .findRoomAvailabilities({
            rooms_ids: action.rooms_ids.join(','),
            from: action.from,
            to: action.to,
            ignore_booking_id: action.ignore_booking_id,
            private_booking: action.private_booking,
            ignore_session_id: action.ignore_session_id,
          })
          .pipe(
            map((response) =>
              roomAvailabilitiesActions.findAllSuccess({
                availabilities: response.data,
              }),
            ),
            catchError((error: ApiError) =>
              of(
                roomAvailabilitiesActions.findAllError({
                  error: error.message,
                }),
              ),
            ),
          );
      }),
    ),
  );
}
